import state from '@/vuex/arquivos-assinados/state.js'
import getters from '@/vuex/arquivos-assinados/getters.js'
import mutations from '@/vuex/arquivos-assinados/mutations.js'
import actions from '@/vuex/arquivos-assinados/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
